export { default as Text } from './Text';
export * from './useTextStyleProps';
